import React from 'react'
import { TextField } from 'office-ui-fabric-react'

export function R2B2PlusForm({
  integrationTypeConfig,
  onIntegrationTypeConfigChange,
  disabled,
  errorCode,
}: {
  integrationTypeConfig: any
  onIntegrationTypeConfigChange: (config: any) => void
  disabled: boolean
  errorCode: string
}) {
  return (
    <>
      <TextField
        label="Custom CSS"
        placeholder=".carodaContainer { float: none; }"
        value={
          integrationTypeConfig.playerOptions
            ? integrationTypeConfig.playerOptions.css || ''
            : ''
        }
        autoComplete="off"
        readOnly={false}
        disabled={disabled}
        multiline={true}
        rows={5}
        onChange={(
          _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
          newValue?: string
        ): void => {
          onIntegrationTypeConfigChange({
            ...integrationTypeConfig,
            playerOptions: {
              ...(integrationTypeConfig.playerOptions || {}),
              css: newValue || '',
            },
          })
        }}
      />
    </>
  )
}
